import React from 'react';
import { Link } from 'gatsby';
import { Category, Subcategory } from '../../../interfaces/Article.interface';
import { handleKeyAction } from '../../../utils/functions';
import './Breadcumbs.scss';

interface Props {
    selectedSubcategory: Category | Subcategory;
    articleName: string;
}

const Breadcumbs = ({ selectedSubcategory, articleName }: Props) => {
    return (
        <nav className="a-breadcumbs">
            <ul>
                <li>
                    <Link
                        to="/"
                        aria-label="Regresar al inicio"
                        onKeyDown={(e) => handleKeyAction(e, '/')}
                    >
                        Centro de ayuda
                    </Link>
                </li>
                <span>/</span>
                <li>
                    <Link
                        to={selectedSubcategory?.url ?? '/'}
                        aria-label={`Ir a ${selectedSubcategory?.name}`}
                        onKeyDown={(e) =>
                            handleKeyAction(e, selectedSubcategory?.url ?? '/')
                        }
                    >
                        {selectedSubcategory?.name}
                    </Link>
                </li>
                {articleName && <span className="slash">/</span>}
                {articleName && <li className="article_name">{articleName}</li>}
            </ul>
        </nav>
    );
};

export default Breadcumbs;
